import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { environment } from 'src/environments/environment';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
interface incub {
  incubatorId: string;
  incubatorName: string;
}
@Component({
  selector: 'app-gallery-add',
  templateUrl: './gallery-add.component.html',
  styleUrls: ['./gallery-add.component.css'],
})
export class GalleryAddComponent implements OnInit {
  protected incubatorNameList: incub[] = [];

  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  galleryForm: FormGroup;
  private saveApi = environment.url + environment.gallerySave;
  private getApi = environment.url + environment.galleryGet;
  private nameListApi = environment.url + environment.incubatorNameList;
  datas;
  /**
   * Component constructor.
   * @param data Dialog data.
   * @param fb FormBuilder.
   * @param makeapi ApiService.
   * @param notify NotifyService.
   * @param sanitizer DomSanitizer.
   * @param dialogRef MatDialogRef<GalleryAddComponent>.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<GalleryAddComponent>
  ) {
    /**
     * Get the dialog data.
     */
    this.datas = data;
    /**
     * If the dialog data title is 'Update', get the gallery details.
     */
    if (data.title == 'Update') {
      this.getGalleryDetails(data._id);
    }
    /**
     * Create the form group with the required fields.
     */
    this.galleryForm = this.fb.group({
      id: [0],
      incubatorId: ['', [Validators.required]],
      galleryTags: ['', [Validators.required]],
      galleryImage: [''],
      galleryImageName: [''],
    });
  }
  get add() {
    return this.galleryForm.controls;
  }
  roleValue;
  /**
   * OnInit lifecycle hook.
   */
  ngOnInit(): void {
    // Get the role from local storage.
    this.roleValue = sessionStorage.getItem('role');
    // Get the form values and set the incubator id to the user id.
    let getform = this.galleryForm.value;
    getform.incubatorId = sessionStorage.getItem('userId');
    // Patch the form values with the new values.
    this.galleryForm.patchValue(getform);
  }
  imageFile: any = [];
  /**
   * Get the gallery details based on the id.
   *
   * @param id the id of the gallery.
   */
  getGalleryDetails(id: string) {
    /**
     * Make a get request to the gallery api with the id.
     */
    this.makeapi.method(this.getApi + id, '', 'get').subscribe((data: any) => {
      /**
       * Patch the form values with the gallery details.
       */
      this.galleryForm.patchValue(data);
      /**
       * Set the image url and image file.
       */
      this.image_url = data.galleryImageName;
      this.imageFile = data.galleryImage;
    });
  }
  namePush = [];
  /**
   * Get the list of incubators.
   */
  incubatorNameApi() {
    /**
     * Make a post request to the incubator name list api.
     */
    this.makeapi.method(this.nameListApi, '', 'post').subscribe((data) => {
      /**
       * Set the incubator name list to the response data.
       */
      this.incubatorNameList = data;
      /**
       * Filter the incubator name list.
       */
      this.filterIncubetor();
    });
  }
  ImageValue: any = [];
  imgFormat: any;
  selecetdImage: File;
  imagetype: any;
  fileValue: File;
  url1: any = 'assets/images/upload.png';
  img_name = '';
  image_url: any = 'assets/images/upload.png';
  img: any;
  logoCheck = false;
  /**
   * Event handler for selecting an image.
   *
   * @param event the event triggered when an image is selected
   */
  onSelectImage(event) {
    this.selecetdImage = event.target.files[0];
    if (event.target.files && this.selecetdImage) {
      const reader = new FileReader();
      const data = this.selecetdImage;
      const imageType = data.type;
      const imageDatatype = imageType.split('/');
      const imgCrtType = imageDatatype[1];

      // Only allow jpeg, jpg, and png formats
      if (
        imgCrtType === 'jpeg' ||
        imgCrtType === 'jpg' ||
        imgCrtType === 'png'
      ) {
        this.img = '';
        this.fileValue = this.selecetdImage;
        reader.readAsDataURL(this.fileValue);
        reader.onload = () => {
          this.url1 = reader.result;
          const spl = this.url1.split(',');
          this.ImageValue = spl[1];
          this.imageFile = spl[1];
          this.img_name = this.fileValue.name;
          this.logoCheck = false;
          // Sanitize the image URL
          this.image_url = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url1
          );
        };
      } else {
        this.img = 'show';
        // Notify the user that only jpeg, jpg, and png formats are allowed
        this.notify.notifyError('Only *jpeg, *jpg, *png formats are allowed');
      }
    }
  }
  /**
   * Save the gallery details.
   *
   * If the image value is empty or the form is invalid, mark all the fields as touched and notify the user.
   * If the form is valid, make a post request to the gallery save api and pass the form values.
   * If the response is successful, notify the user and close the dialog.
   * If the response is not successful, notify the user with the error message.
   */
  saveGallery() {
    let getform = this.galleryForm.value;
    if (this.imageFile == '' || this.galleryForm.invalid) {
      // If the image value is empty or the form is invalid, mark all the fields as touched and notify the user.
      if (this.imageFile == '') {
        this.logoCheck = true;
      }
      this.galleryForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // If the form is valid, add the image details to the form values.
      if (this.ImageValue != '') {
        getform.galleryImageName = this.img_name;
        getform.galleryImage = this.ImageValue;
      }
      // Make a post request to the gallery save api and pass the form values.
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        if (data.responseStatus == 'Success') {
          // If the response is successful, notify the user and close the dialog.
          this.notify.notifysuccess(data.responseMessage);
          this.cancelGallery();
        } else {
          // If the response is not successful, notify the user with the error message.
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Close the dialog without saving the gallery details.
   *
   * Reset the gallery form and close the dialog.
   */
  cancelGallery() {
    this.galleryForm.reset();
    this.dialogRef.close();
  }

  protected _onDestroy = new Subject();
  /**
   * Filters the incubator list based on the filter control's value changes.
   * Sets the initial value of the incubator name and updates the list value.
   * Subscribes to value changes of the filter control to apply filtering.
   */
  filterIncubetor() {
    // Set the initial value of the incubatorName control
    this.incubatorName.setValue(this.incubatorNameList[1]);

    // Initialize the incubator list value
    this.incubatorListValue.next(this.incubatorNameList.slice());

    // Subscribe to changes in the filter control value
    this.incubatorFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)) // Automatically unsubscribe on component destroy
      .subscribe(() => {
        // Apply the filter to the incubator list
        this.filterBanks();
      });
  }
  /**
   * Destroys the component, unsubscribing from any subscriptions and
   * completing the subject.
   */
  ngOnDestroy() {
    // Unsubscribe from any subscriptions
    this._onDestroy.next();
    // Complete the subject
    this._onDestroy.complete();
  }
  /**
   * Sets the initial value of the incubator select control.
   * Subscribes to the first value of the incubator list value and sets the compareWith
   * function of the singleSelect control to compare the incubator name strings.
   */
  protected setInitialValue() {
    this.incubatorListValue
      .pipe(
        // Take the first value of the incubator list value
        take(1),
        // Automatically unsubscribe on component destroy
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        // Compare the incubator name strings
        this.singleSelect.compareWith = (a: incub, b: incub) =>
          a && b && a.incubatorName === b.incubatorName;
      });
  }
  /**
   * Filters the incubator name list based on the current value of the filter control.
   * Updates the incubator list value with the filtered results.
   * If no search term is provided, the full list is returned.
   */
  protected filterBanks() {
    // Check if the incubator name list is available
    if (!this.incubatorNameList) {
      return;
    }

    // Get the current search term from the filter control
    let search = this.incubatorFilterCtrl.value;

    if (!search) {
      // If no search term is provided, return the full list
      this.incubatorListValue.next(this.incubatorNameList.slice());
      return;
    } else {
      // Convert the search term to lowercase for case-insensitive comparison
      search = search.toLowerCase();
    }

    // Filter the incubator name list based on the search term and update the list value
    this.incubatorListValue.next(
      this.incubatorNameList.filter(
        (val) => val.incubatorName.toLowerCase().indexOf(search) > -1
      )
    );
  }
}
